<template>
    <div class="page bg-fff page-flex">
        <appStatus :statusHeight="statusHeight"></appStatus>
        <div class="page-input-title" :style="{top:statusHeight+'rem'}">
            <div class="alifont icon-back left-icon click" @click="back"></div>
            <input type="search" @keyup.13="handleQuery" class="center-input fs-28" placeholder="搜索订单(手机号、订单号、顾客)"
                   v-model="queryKey">
            <div class="right fs-28 color-333 click" @click="handleQuery">
                搜索
            </div>
        </div>
        <div class="mt-30 flex-between flex-center pd-025">
            <div class="fs-32 color-333 font-bold">最近搜索</div>
            <div class="fs-28 color-999 click" @click="clean">清空记录</div>
        </div>
        <div class="mt-5 word-list pd-025">
            <div class="word-item click" v-for="(item,$index) in historyList" @click="queryKey = item;handleQuery()">{{item}}</div>
        </div>
    </div>
</template>

<script>
    import appStatus from "@/components/appStatus/index"
    import getAppStatusHeight from "@/mixins/getAppStatusHeight";
    export default {
        name: "search",
        mixins: [getAppStatusHeight],
        components: {appStatus},
        data(){
            return{
                queryKey:'',
                historyList: JSON.parse(localStorage.getItem('orderSearchKeyword')) || [],
            }
        },
        methods:{
            back() {
                if (this.isBackClose) {
                    try {
                        window.native.onFinish();
                    } catch (e) {

                    }
                } else {
                    try {
                        window.native.onBack();
                    } catch (e) {
                        this.$router.go(-1)
                    }
                }
            },
            handleQuery(){
                let _this = this;
                if(!this.queryKey){
                    this.$toast('请输入搜索关键字');
                    return
                }else{
                    let hasHistory = false;
                    this.historyList.forEach(item=>{
                        if(item == _this.queryKey){
                            hasHistory = true;
                            return
                        }
                    });
                    if(!hasHistory){
                        this.historyList.push(_this.queryKey);
                        localStorage.setItem('orderSearchKeyword',JSON.stringify(this.historyList));
                    }
                    this.$router.push({name:'lockerOrderSearchResult',query:{keyWord:this.queryKey}});
                }
            },
            clean(){
                this.historyList = [];
                localStorage.setItem('orderSearchKeyword',JSON.stringify([]))
                this.$toast("清空成功");
            },
        }
    }
</script>

<style scoped lang="scss">
    .word-list{
        display: flex;
        flex-wrap: wrap;
        .word-item{
            margin-top: .24rem;
            height: .56rem;
            line-height: .56rem;
            padding: 0 .16rem;
            border-radius: .08rem;
            background: #f5f5f5;
            font-size: .28rem;
            color: #333;
            margin-right: .24rem;
        }
    }

</style>



// WEBPACK FOOTER //
// search.vue?6201aa36